import {Component, Inject, Input, OnChanges, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {DeploymentSetStatus} from '../model/deployment-set';
import {FilesService} from '../services/files.service';
import {Utils} from '../common/utils';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {EnvConfigurationService} from '../services/config/env-configuration.service';
import {ErrorHelper} from '../common/ErrorHelper';
import {NotifierService} from 'angular-notifier';


@Component({
  selector: 'app-dynamic-set-details',
  templateUrl: './dynamic-set-details.component.html',
  styleUrls: ['./dynamic-set-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DynamicSetDetailsComponent implements OnInit, OnChanges {

  @Input() deploymentSetId: string;

  isFeatureQualityReportEnabled: boolean;

  dss: DeploymentSetStatus;
  filesByType: {};
  meta: any;
  qualityReport: any;
  datasources: {};
  datasourceMeta: MatTableDataSource<any>;

  displayedColumnsMeta: string[] = ['type', 'fileName'];

  @ViewChild('mSort') sortMeta: MatSort;

  constructor(private filesService: FilesService,
              public dialog: MatDialog,
              public notifierService: NotifierService) {
  }

  ngOnInit(): void {
    this.isFeatureQualityReportEnabled = EnvConfigurationService.configuration.FEATURE_QUALITY_REPORT_ENABLED;
  }

  ngOnChanges(): void {
    this.loadDataAsync();
  }

  async loadDataAsync(): Promise<any> {
    try {
      await this.loadData();
    } catch (error) {
      console.log(error);
    }
  }

  loadData(): Promise<boolean> {
    this.datasources = {};
    this.datasourceMeta = new MatTableDataSource(this.meta);
    return new Promise<boolean>((resolve, reject) => {
      this.filesService.getStatus(this.deploymentSetId).toPromise().then(
        data => {
          this.dss = data;
          this.filesByType = Utils.groupBy(this.dss.uploadPacks, ['type']);
          this.meta = this.dss.meta;
          this.qualityReport = this.dss.qualityReport;
          this.datasourceMeta = new MatTableDataSource(this.meta);
          this.datasourceMeta.sort = this.sortMeta;

          Object.entries(this.filesByType).forEach(([key, value]) => {
            const datasource = new MatTableDataSource(Array.from(value[0].files));
            this.datasources[key] = datasource;
          });
          resolve(true);
        },
        (error) => {
          const errorMessage = ErrorHelper.disectError('get status', error);
          this.notifierService.notify('error', errorMessage);
          resolve(false);
        });
    });

  }

  showQualityReport(): void {
    this.dialog.open(DialogDataQualityReportComponent, {
      data: {
        text: this.qualityReport
      },
      width: '1000px',
      maxWidth: '100vw',
    });
  }

}

@Component({
  selector: 'app-dialog-data-quality-report',
  templateUrl: 'dialog-data-quality-report.component.html',
})
export class DialogDataQualityReportComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }
}

export interface DialogData {
  text: string;
}

